import { render, staticRenderFns } from "./index.vue?vue&type=template&id=924c0c7e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=924c0c7e&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=924c0c7e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924c0c7e",
  null
  
)

export default component.exports